import { all, takeLatest, put, call } from 'redux-saga/effects';
import { onGetReporting, onGetProfitabilityReporting, onGetRiskOutliersReporting } from './api';

import {
  getReporting,
  getReportingSucceeded,
  getReportingFailed,
  getProfitabilityReporting,
  getProfitabilityReportingSucceeded,
  getProfitabilityReportingFailed,
  getRiskOutliersReporting,
  getRiskOutliersReportingSucceeded,
  getRiskOutliersReportingFailed
} from './slice';

export function* getReportingWorker({ payload }) {
  try {
    const response = yield call(onGetReporting, payload);
    yield put(getReportingSucceeded(response.data));
  } catch {
    yield put(getReportingFailed());
  }
}

export function* getProfitabilityReportingWorker({ payload }) {
  try {
    const response = yield call(onGetProfitabilityReporting, payload);
    yield put(getProfitabilityReportingSucceeded(response.data));
  } catch {
    yield put(getProfitabilityReportingFailed());
  }
}

export function* getRiskOutliersReportingWorker() {
  try {
    const response = yield call(onGetRiskOutliersReporting);
    yield put(getRiskOutliersReportingSucceeded(response.data));
  } catch {
    yield put(getRiskOutliersReportingFailed());
  }
}

export default function* reportingSaga() {
  yield all([
    takeLatest(getReporting.type, getReportingWorker),
    takeLatest(getProfitabilityReporting.type, getProfitabilityReportingWorker),
    takeLatest(getRiskOutliersReporting.type, getRiskOutliersReportingWorker)
  ]);
}
